import { requestType } from '~/config/enum.config';
var SERVICE = 'common-service';
var CONTROLLER = 'dataDictController';
export default {
    /**
     * 获取数据字典
     */
    getAll: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAll',
        type: requestType.Get
    },
    /**
     * 获取数据字典HASH
     */
    getHashCode: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getHashCode',
        type: requestType.Get
    },
    /**
     * 获取哈希Code
     */
    getDataDictHashCode: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getDataDictHashCode',
        type: requestType.Get
    },
};
